import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const [activeTab, setActiveTab] = useState("trabalhista");

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="w-full bg-[#ABB3A4] text-black">
      {/* Video de Fundo */}
      <div className="relative w-full h-screen">
        <video className="absolute inset-0 w-full h-full object-cover" autoPlay loop muted>
          <source src="/videos/lawyer.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white text-center p-6">
          <h1 className="text-5xl font-bold mb-4">Protegendo seus Direitos com Excelência</h1>
          <p className="text-lg max-w-2xl">
            Nosso escritório de advocacia está comprometido com a justiça, garantindo a melhor defesa para os nossos clientes em diversas áreas do direito.
          </p>
        </div>
      </div>

      {/* Slider de Serviços */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-center">
        <h2 className="text-4xl font-semibold mb-6">Nossos Serviços</h2>
        <Slider {...sliderSettings} className="max-w-4xl mx-auto">
          <div>
            <a href="/trabalhista" className="block bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold">Direito Trabalhista</h3>
              <p className="mt-2">Defendemos os direitos dos trabalhadores em casos de rescisão, assédio, acidente de trabalho e mais.</p>
            </a>
          </div>
          <div>
            <a href="/previdenciario" className="block bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold">Direito Previdenciário</h3>
              <p className="mt-2">Assistência para aposentadorias, revisões de benefícios e questões previdenciárias junto ao INSS.</p>
            </a>
          </div>
          <div>
            <a href="/civil" className="block bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold">Direito Civil</h3>
              <p className="mt-2">Atuamos em contratos, responsabilidade civil, direito do consumidor e inventários.</p>
            </a>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Home;